import ReNewCertInfo from "pages/renewcert/viewinforrenew/ReNewCertInfo";

export default ReNewCertInfo